export const formatNumber = (value) => {
  if (value === null || value === undefined) {
    return "-";
  }
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatScheduleType = (type) => {
  const map = {
    GENERAL: "一般",
    BIWEEKLY_FLEX: "雙週變形工時",
    FOURWEEK_FLEX: "四週變形工時",
  };
  return map[type] || type;
};
